import React, { Component } from 'react';
import { GoogleApiWrapper, Map, Circle, InfoWindow } from 'google-maps-react';
import {LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer} from 'recharts';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';

const API_LATLNG = 'https://covid19.tmsoftwareinc.com/api/v1/latlngs?lat=';
const API_ADR = 'https://covid19.tmsoftwareinc.com/api/v1/addresses?country=';
const API_GEO = 'https://covid19.tmsoftwareinc.com/api/v1/geos?location=';
const API_BOUNDS = 'https://covid19.tmsoftwareinc.com/api/v1/bounds';
const API_CIRCLESCALE = 'https://covid19.tmsoftwareinc.com/circlescale.txt';
// const API_BOUNDS = 'http://192.168.2.2:3000/v1/bounds?north=';

/*
let caseCircles = [
    {
      city: 'Studio City',
      county: 'Los Angeles',
      state: 'California',
      country: 'us',
      cases: 200,
      lat: 34.139619,
      lng: -118.38
    },
    {
      city: 'glendale',
      county: 'Los Angeles',
      state: 'California',
      country: 'us',
      cases: 100,
      lat: 34.139619,
      lng: -118.43
    },
    {
      city: 'Van nuyes',
      county: 'Los Angeles',
      state: 'California',
      country: 'us',
      cases: 3000,
      lat: 34.139619,
      lng: -118.55
    },
  ];
  */
  

class GoogleMap extends Component {
  state = {
    showingInfoWindow: false,
    activeMarker: {},
    // HW Upper School
    lat: 34.139619,
    lng: -118.412786,
    city: null,
    county: null,
    state: null,
    country: null,
    date: null,
    cases: null,
    newcases: null,
    sevenrate: null,
    cityJsonData: null,
    countyJsonData: null,
    stateJsonData: null,
    countryJsonData: null,
    cityTabDisabled: false,
    countyTabDisabled: false,
    stateTabDisabled: false,
    countryTabDisabled: false,
    tabIndex: 0,
    usage: 'Usage: Click (Tap) to see data there.',
    showingInfoWindowCircle: false,
    latCircle: null,
    lngCircle: null,
    caseCircles: [],
    circleScale: 100,
    boundNorth: null,
    boundSouth: null,
    boundEast: null,
    boundWest: null,
  }

  searchLocation = 'Harvard-Westlake Upper School';
  chartHeight = 100;

  getCases() {
    // this.state.lat, lng: this.state.lng
    fetch(API_LATLNG+this.state.lat+'&long='+this.state.lng)
    .then(res => res.json())
    .then((data) => {
      if(data.length === 0) {
        this.setState({
          city: null,
          county: null,
          state: null,
          country: null,
          date: null,
          cases: 'No Data Found Here',
          newcases: null,
          sevenrate: null,
          showingInfoWindow: true,
          activeMarker: {},
          cityJsonData: null,
          countyJsonData: null,
          stateJsonData: null,
          countryJsonData: null,
          tabIndex: 0,
          cityTabDisabled: false,
          countyTabDisabled: false,
          stateTabDisabled: false,
          countryTabDisabled: false,
        });
      }
      else {
        if(data[0]['country'] === 'us' && data[0]['county'] !=='New York City') {
          this.setState({county: data[0]['county']+ ' County'})
        }
        else {
          this.setState({county: data[0]['county']})
        }
  // city existence is assumed at first
      this.setState({
        city: data[0]['city'],
  //      county: data[0]['county'],
        state: data[0]['state'],
        country: data[0]['country'],
        date: data[0]['date'],
        cases: data[0]['cases'] + ' cases',
        newcases: ', ' + data[0]['newcases'] + ' newcases',
        sevenrate: ', ' + data[0]['7rate'] + ' cases/day/100k',
        showingInfoWindow: true,
        activeMarker: {},
        cityJsonData: data,
        countyJsonData: null,
        stateJsonData: null,
        countryJsonData: null,
        tabIndex: 0,
        cityTabDisabled: false,
        countyTabDisabled: false,
        stateTabDisabled: false,
        countryTabDisabled: false,
      });
      if(data[0]['newcases'] === -1) {
        this.setState({
          newcases: ''
        });
      }
      if(data[0]['7rate'] === -1) {
        this.setState({
          sevenrate: ''
        });
      }
 // Move json Data step by step     
      if(data[0]['city'] === '') {
        this.setState({
          tabIndex: 1,
          cityTabDisabled: true,
          cityJsonData: null,
          countyJsonData: data
        });
        if(data[0]['county'] === '') {
          this.setState({
            tabIndex: 2,
            countyTabDisabled: true,
            countyJsonData: null,
            stateJsonData: data
          });
          if(data[0]['state'] === '') {
            this.setState({
              tabIndex: 3,
              stateTabDisabled: true,
              stateJsonData: null,
              countryJsonData: data
            });
          }
          else {
            fetch(API_ADR+data[0]['country'])
            .then(res4 => res4.json())
            .then((data4) => {
              this.setState({
                countryTabDisabled: false,
                countryJsonData: data4
              });
            });
          }
        } 
        else {
// Get state data
          fetch(API_ADR+data[0]['country']+'&state='+data[0]['state'])
          .then(res3 => res3.json())
          .then((data3) => {
            this.setState({
              countryTabDisabled: true,
              stateJsonData: data3
            });
          });
        }
      }
      else {
        // Get county data
        fetch(API_ADR+data[0]['country']+'&state='+data[0]['state']+'&county='+data[0]['county'])
        .then(res2 => res2.json())
        .then((data2) => {
        this.setState({
          tabIndex: 0,
          countyJsonData: data2
          });
        });

        // Get state data
        fetch(API_ADR+data[0]['country']+'&state='+data[0]['state'])
        .then(res3 => res3.json())
        .then((data3) => {
        this.setState({
          tabIndex: 0,
          countryTabDisabled: true,
          stateJsonData: data3
          });
        });
      }
      }
    })
    .catch(console.log)
  }

  componentDidMount() {
    navigator.geolocation.getCurrentPosition((position) => {
      this.setState({
        lat: position.coords.latitude,
        lng: position.coords.longitude
      });
      this.getCases();
    },
    (err) => {
      this.getCases();
      console.log(err);
    })
  }

  mapClicked = (mapProps, map, event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    this.setState({
      lat: lat,
      lng: lng
    });
    this.getCases();
  }

  mapReady = (mapProps, map, event) => {
  //  let rect = map.getBounds();
  
//    console.log('idle Evented');
//    console.log('idle getBounds= '+rect.getSouthWest()+':'+rect.getNorthEast());
    /*
    console.log('idle getBounds= '+rect.getSouthWest().lat()+':'+rect.getSouthWest().lng());
    console.log('idle getBounds= '+rect.getNorthEast().lat()+':'+rect.getNorthEast().lng());
    */
//    let north = rect.getNorthEast().lat();
//    let east = rect.getNorthEast().lng();
//    let south = rect.getSouthWest().lat();
//    let west = rect.getSouthWest().lng();
//    console.log(north, ' ', south, ' ', east, ' ' ,west);
    /*
    if(this.state.boundNorth === north && this.state.boundSouth === south && this.state.boundEast === east && this.state.boundWest === west) {
      return;
    }
    else {
      this.setState({
        oundNorth: north,
        boundSouth: south,
        boundEast: east,
        boundWest: west,
      });
    }
    */
    let north = 0;
    let east = 0;
    let south = 0;
    let west = 0;
//    let url = API_BOUNDS+north+'&south='+south+'&east='+east+'&west='+west;
    let url = API_BOUNDS;
//    console.log(url);
    fetch(url)
        .then(res => res.json())
        .then((data) => {
          
          this.setState({
            caseCircles: data
          });
          // Sort caseCircles by sevenrate
          this.state.caseCircles.sort((a,b) => b.sevenrate-a.sevenrate );
    });

    let url2 = API_CIRCLESCALE;
    fetch(url2)
        .then(res2 => res2.json())
        .then((data2) => {
          
          this.setState({
            circleScale: data2
          });
    });

  }

  onMarkerClick = (props, marker, e) => {
    this.setState({
      activeMarker: marker
    });
  }

  onSearchLocationKeyPress = (event) => {
    if(event.keyCode === 13) {
      this.onSearchButtonClick();
    }
  }

  onSearchLocationChange = (event) => {
    this.searchLocation = event.target.value;
  }

  onSearchButtonClick = (event) => {
    fetch(API_GEO+this.searchLocation)
    .then(res => res.json())
    .then((data) => {
      this.setState({
        lat: data['lat'],
        lng: data['lng'],
        showingInfoWindow: false
      });
      this.getCases();
    });
  }

  //showCasesCircle(show, lat, lng, cases) {
  //  this.setState({
  //    showingInfoWindowCircle: show,
  //    latCircle: lat,
  //    lngCircle: lng,
  //    casesCircle: cases
  //  });
  // }

  render() {
    return (
      <div>
        <div class="w-section section ">
        <div class="mobilenoshow centering">Click on the map to see COVID-19 case information there.</div>
        <div class="mobilenoshow centering">Radius of the red circles are proportional to the case rate there.</div>
        <div class="mobilenoshow centering">Case rate is the average new cases in the last 7 days per 100k population.</div>
        <div class="mobileshow centering">Tap on the map for COVID-19 cases there.</div>
        <div class="w-container centering">
        <input type='text' size="30" placeholder="City, State, Country" onChange={this.onSearchLocationChange} onKeyDown={this.onSearchLocationKeyPress} />&nbsp;
        <button class="button small-button" onClick={this.onSearchButtonClick}>Search</button>
        </div>

        <div class="mobilenoshow centering">
          <h3>Case rates and new cases in SoCal cities/communities</h3>
    <table>
    <thead>
    <tr><th class="th_country">County</th><th class="th_city">City/Community</th><th class="th_newcases">New Cases</th><th class="th_caserate">Case Rate</th><th class="th_caserate">Date</th></tr>
    </thead>
    <tbody>
    {this.state.caseCircles.map((item,key) => {
          return <tr><td class="td_country">{item.county}</td><td class="td_city">{item.city}</td><td class="td_newcases">{item.newcases}</td><td class="td_caserate">{item.sevenrate}</td><td class="td_caserate">{item.date.substring(0,10)}</td></tr>
    }
    )}
    </tbody>
    </table>
    </div>

      </div>
      <br />
      <div class="w-section section purple " id="chart">
        &nbsp;&nbsp;Daily new cases
      <Tabs selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.setState({ tabIndex })} >
      <TabList>
      <Tab disabledClassName="react-tabs__tab--disabled-hidden" disabled={this.state.cityTabDisabled} >{this.state.city}</Tab>
      <Tab disabledClassName="react-tabs__tab--disabled-hidden" disabled={this.state.countyTabDisabled}>{this.state.county}</Tab>
      <Tab disabledClassName="react-tabs__tab--disabled-hidden" disabled={this.state.stateTabDisabled}>{this.state.state}</Tab>
      <Tab disabledClassName="react-tabs__tab--disabled-hidden" disabled={this.state.countryTabDisabled}>{this.state.country}</Tab>
    </TabList>
      <TabPanel>
      <ResponsiveContainer width="95%" height={this.chartHeight}>
        <LineChart data={this.state.cityJsonData}>
        <XAxis dataKey="date" reversed/>
        <YAxis/>
        <Line type="monotone" dataKey="newcases" stroke="#8884d8" />
        <Tooltip />
        </LineChart>
      </ResponsiveContainer>
      </TabPanel>
      <TabPanel>
      <ResponsiveContainer width="95%" height={this.chartHeight}>
        <LineChart data={this.state.countyJsonData}>
        <XAxis dataKey="date" reversed/>
        <YAxis/>
        <Line type="monotone" dataKey="newcases" stroke="#8884d8" />
        <Tooltip />
        </LineChart>
      </ResponsiveContainer>
    </TabPanel>
    <TabPanel>
      <ResponsiveContainer width="95%" height={this.chartHeight}>
        <LineChart data={this.state.stateJsonData}>
        <XAxis dataKey="date" reversed/>
        <YAxis/>
        <Line type="monotone" dataKey="newcases" stroke="#8884d8" />
        <Tooltip />
        </LineChart>
      </ResponsiveContainer>
    </TabPanel>
    <TabPanel>
      <ResponsiveContainer width="95%" height={this.chartHeight}>
        <LineChart data={this.state.countryJsonData}>
        <XAxis dataKey="date" reversed/>
        <YAxis/>
        <Line type="monotone" dataKey="newcases" stroke="#8884d8" />
        <Tooltip />
        </LineChart>
      </ResponsiveContainer>
    </TabPanel>
      </Tabs>
      </div>
      <Map
        google = { this.props.google }
        zoom = { 12 }
        style={{width: '100%', height: '100%', position: 'static'}}
        center = {{ lat: this.state.lat, lng: this.state.lng }}
        initialCenter = {{ lat: this.state.lat, lng: this.state.lng }}
        zoomControlOptions = { {position: this.props.google.maps.ControlPosition.TOP_RIGHT} }
        StreetViewControl = { false }
        onClick={this.mapClicked}
        onReady={this.mapReady}
      >
        {this.state.caseCircles.map((item) => (
          <Circle
          radius={item.sevenrate*this.state.circleScale}
          center = {{ lat: item.lat, lng: item.lng }}
          onClick={this.mapClicked}
          strokeColor='transparent'
          strokeOpacity={0}
          strokeWeight={5}
          fillColor='#FF0000'
          fillOpacity={0.2}
        />
        ))}
        
        <InfoWindow
          visible = { this.state.showingInfoWindow }
          position = {{ lat: this.state.lat, lng: this.state.lng }}
        >
          <div>
            <h4>{this.state.city}:{this.state.county}:{this.state.state}:{this.state.country}<br /> 
        {this.state.date}: total {this.state.cases} {this.state.newcases} {this.state.sevenrate}<br />
        </h4>
          </div>
        </InfoWindow>
      </Map>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: (process.env.REACT_APP_MAP_API_KEY)
})(GoogleMap);